/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const portfolio_analytics_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#portfolio_analytics_medium_svg__a)">
      <path
        fill="#000"
        d="M18.03 16.97a.75.75 0 1 0-1.06 1.06l1.06-1.06Zm4.44 6.56a.75.75 0 1 0 1.06-1.06l-1.06 1.06ZM14.138 7h.75a.75.75 0 0 0-.75-.75V7Zm-3.844 3.898-.534-.527.534.527Zm-1.011.084.44-.607-.44.607ZM7.56 9.736l-.44.607.44-.607Zm-.946.026-.472-.583a.749.749 0 0 0-.018.015l.49.568ZM3.51 11.449a.75.75 0 1 0 .98 1.136l-.98-1.136ZM11 6.25a.75.75 0 0 0 0 1.5v-1.5Zm2.388 3.932a.75.75 0 0 0 1.5 0h-1.5Zm3.582 7.848 5.5 5.5 1.06-1.06-5.5-5.5-1.06 1.06Zm.28-8.53a7.75 7.75 0 0 1-7.75 7.75v1.5a9.25 9.25 0 0 0 9.25-9.25h-1.5ZM9.5 17.25A7.75 7.75 0 0 1 1.75 9.5H.25a9.25 9.25 0 0 0 9.25 9.25v-1.5ZM1.75 9.5A7.75 7.75 0 0 1 9.5 1.75V.25A9.25 9.25 0 0 0 .25 9.5h1.5ZM9.5 1.75a7.75 7.75 0 0 1 7.75 7.75h1.5A9.25 9.25 0 0 0 9.5.25v1.5Zm4.104 4.723L9.76 10.371l1.068 1.053 3.844-3.897-1.068-1.054ZM9.76 10.371a.03.03 0 0 1-.019.01l.126 1.494a1.53 1.53 0 0 0 .961-.451L9.76 10.371Zm-.019.01a.03.03 0 0 1-.018-.006l-.88 1.215c.296.214.659.316 1.024.285L9.74 10.38Zm-.018-.006L8 9.128l-.88 1.215 1.723 1.247.88-1.215ZM8 9.128a1.527 1.527 0 0 0-.938-.29l.042 1.5c.004 0 .01 0 .016.005L8 9.128Zm-.938-.29c-.336.01-.66.13-.92.341l.945 1.165a.029.029 0 0 1 .017-.007l-.042-1.499Zm-.938.356L3.51 11.449l.98 1.136 2.614-2.256-.98-1.135ZM11 7.75h3.138v-1.5H11v1.5ZM13.388 7v3.182h1.5V7h-1.5Z"
      />
    </g>
    <defs>
      <clipPath id="portfolio_analytics_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default portfolio_analytics_medium
